import { TFunction } from "i18next";
import { UnitValueDto } from "../rubblemaster_openapi3_typescript-fetch";
import moment, { Moment, MomentInput } from "moment";

export class FormatHelper {
  constructor(
    private readonly t: TFunction
  ) {}
  
  public formatUnitValue (
    unitValue: UnitValueDto | null,
    fallbackUnitTranslation?: string,
    noDataTranslation?: string
  ): string {
    if (unitValue?.value === undefined){
      return noDataTranslation ?? this.t('graph.noData');
    }

    return `${unitValue.value.toFixed(2)} ${unitValue.unit ?? fallbackUnitTranslation}`;
  };

  public formatUnitValueExceptZero (
    unitValue: UnitValueDto | null,
    fallbackUnitTranslation?: string,
    noDataTranslation?: string,
    zeroTranslation = '-'
  ): string {
    if (unitValue?.value === undefined){
      return noDataTranslation ?? this.t('graph.noData');
    }

    if (unitValue.value === 0){
      return zeroTranslation;
    }

    return `${unitValue.value.toFixed(2)} ${unitValue.unit ?? fallbackUnitTranslation}`;
  };

  public formatSuffixedNumber(
    number: number | null | undefined,
    suffix: string,
    noDataTranslation?: string,
    fractionDigits = 2
  ): string {
    if (number === null || number === undefined){
      return noDataTranslation ?? this.t('graph.noData');
    }

    return `${number.toFixed(fractionDigits)} ${suffix}`;
  }

  public formatTimeframe(
    startDate: Moment, 
    endDate: Moment,
    format: string
  ): string {
    return `${startDate.format(format)} ${this.t('report.till')} ${endDate.format(format)}`;
  }

  public static formatTimestamp(
    timestamp: MomentInput | null | undefined,
    format = 'DD.MM.YYYY HH:mm',
    noDataTranslation = '-'
  ): string {
    if (timestamp === null || timestamp === undefined){
      return noDataTranslation;
    }

    return moment
      .utc(timestamp)
      .local()
      .format(format);
  }
}